import React from "react"
import { Accordion as BSAccordion } from "react-bootstrap"
import { AccordionEventKey } from "react-bootstrap/esm/AccordionContext"

import classNames from "classnames"

import { OptionRenderer, TabType } from "shared/types/Tab"

import { AccordionButton } from "./AccordionButton"

export interface AccordionItemProps<
  T = void,
  P = void,
  ElementType extends HTMLElement = HTMLDivElement
> {
  eventKey: string
  isExpanded: boolean
  tab: TabType<T>
  isSelected?: boolean
  isDisabled?: boolean
  ButtonRenderer?: OptionRenderer<T, P, ElementType>
  payload?: P
  onSelect?: (eventKey: string) => void
  onExpand?: (eventKey: AccordionEventKey) => void
}

function AccordionItemComponent<
  T = void,
  P = void,
  ElementType extends HTMLElement = HTMLDivElement
>(props: AccordionItemProps<T, P, ElementType>) {
  const { ButtonRenderer, tab, eventKey, ...rest } = props
  const { content, className } = tab

  return (
    <BSAccordion.Item
      id={eventKey}
      eventKey={eventKey}
      className={classNames(className, { "no-content": !content })}
    >
      <AccordionButton {...props} {...rest} />
      {content ? (
        <BSAccordion.Body id="accordion-body">{content}</BSAccordion.Body>
      ) : null}
    </BSAccordion.Item>
  )
}
export const AccordionItem = React.memo(
  AccordionItemComponent
) as typeof AccordionItemComponent
